"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = settings;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var INITIAL_STATE = {
  settings: {
    // get request
    isFetching: false,
    fetchingHasError: false,
    fetchingRecentError: undefined,
    lastFetched: undefined,
    // put request
    hasBeenSubmitted: false,
    isSubmitting: false,
    submitHasError: false,
    submitRecenterError: undefined,
    dismissedScriptLoaderBanner: false,
    unsavedChanges: false,
    nextPanelName: undefined,
    original: {
      popupSuggestedColors: []
    },
    temporal: {
      popupSuggestedColors: []
    }
  }
};

function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.settings;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var original;
  var temporal;

  switch (action.type) {
    case _ActionTypes.REQUEST_SETTINGS:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _ActionTypes.RECEIVE_SETTINGS:
      original = Object.assign({}, state.original, action.payload);
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: false,
        lastFetched: action.meta.timestamp,
        original: original,
        temporal: original
      });

    case _ActionTypes.ERROR_SETTINGS:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: action.error,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.SUBMIT_SETTINGS_FORM:
      return Object.assign({}, state, {
        hasBeenSubmitted: true,
        isSubmitting: true
      });

    case _ActionTypes.SUCCESS_SETTINGS_FORM:
      original = Object.assign({}, state.original, action.payload);
      return Object.assign({}, state, {
        isSubmitting: false,
        submitHasError: false,
        original: original,
        temporal: original
      });

    case _ActionTypes.ERROR_SETTINGS_FORM:
      return Object.assign({}, state, {
        isSubmitting: false,
        submitHasError: action.error,
        submitRecenterError: action.payload
      });

    case _ActionTypes.SUCCESS_REMOVE_LAST_EMAIL_SYNC_ERROR:
      original = Object.assign({}, state.original, {
        espLastError: null
      });
      temporal = Object.assign({}, state.temporal, {
        espLastError: null
      });
      return Object.assign({}, state, {
        original: original,
        temporal: temporal
      });

    case _ActionTypes.ERROR_REMOVE_LAST_EMAIL_SYNC_ERROR:
      return Object.assign({}, state);

    case _ActionTypes.UNSAVED_CHANGES:
      return Object.assign({}, state, {
        unsavedChanges: true,
        nextPanelName: action.nextPanelName
      });

    case _ActionTypes.DISMISS_SCRIPTLOADER_BANNER:
      return Object.assign({}, state, {
        dismissedScriptLoaderBanner: true
      });

    case _ActionTypes.SAVED_CHANGES:
      return Object.assign({}, state, {
        unsavedChanges: false,
        nextPanelName: undefined
      });

    case _ActionTypes.UPDATE_SETTINGS_TEMPORAL:
      temporal = Object.assign({}, state.temporal, action.payload);
      return Object.assign({}, state, {
        temporal: temporal
      });

    case _ActionTypes.RESTORE_SETTINGS_TEMPORAL:
      return Object.assign({}, state, {
        temporal: state.original
      });

    default:
      return state;
  }
}